import { render, staticRenderFns } from "./OffersOrPlansContainer.vue?vue&type=template&id=843c61da&scoped=true&"
import script from "./OffersOrPlansContainer.vue?vue&type=script&lang=js&"
export * from "./OffersOrPlansContainer.vue?vue&type=script&lang=js&"
import style0 from "./OffersOrPlansContainer.vue?vue&type=style&index=0&id=843c61da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843c61da",
  null
  
)

export default component.exports